function CliniciansPage() {
    return <div>This is the Clinicians content</div>
  }

export default CliniciansPage